// src/utils/detectPayloadKind.js
// Which Inspect tab a pasted payload belongs to. Pure and cheap — it runs on
// every keystroke in InspectPage's shared paste box.
//
//   'vast' — VAST/VMAP XML (the VAST tab sends it to the proxy's parser)
//   'ortb' — any JSON object/array (OpenRTB lint reports a non-ORTB shape itself)
//   'gam'  — a URL or bare query string; the explainer says when it isn't GAM
//   null   — empty, or nothing recognisable: leave the current tab alone
//
// VAST is tested before JSON on purpose: a VAST document is never valid JSON,
// but the reverse check would need a full parse of every XML paste.

const VAST_ROOT = /<\s*(?:\w+:)?(?:VAST|VMAP)\b/i;

export function detectPayloadKind(text) {
  const t = typeof text === 'string' ? text.replace(/^\uFEFF/, '').trim() : '';
  if (!t) return null;

  if (t.startsWith('<')) return VAST_ROOT.test(t) ? 'vast' : null;

  if (t.startsWith('{') || t.startsWith('[')) {
    try {
      const v = JSON.parse(t);
      return v && typeof v === 'object' ? 'ortb' : null;
    } catch {
      return null; // half-pasted JSON — don't flip tabs mid-paste
    }
  }

  if (/^(?:https?:)?\/\//i.test(t) || /^\/?[\w./-]*\?/.test(t) || /(?:^|[?&])(?:iu|iu_parts|sz|correlator)=/.test(t)) {
    return 'gam';
  }
  return null;
}

export const PAYLOAD_KIND_LABEL = {
  gam: 'GAM ad request',
  ortb: 'OpenRTB JSON',
  vast: 'VAST / VMAP XML',
};
